Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.MouseCursor = module.exports.default = {
	ARROW: "arrow",
	AUTO: "auto",
	BUTTON: "button",
	HAND: "hand",
	IBEAM: "ibeam"
};